(function(){
  if(window.__neralvoArticleEnhancements)return;
  window.__neralvoArticleEnhancements=true;

  function imageFilename(src){
    try{return new URL(src,window.location.origin).pathname.split('/').pop().replace(/_[0-9]+x[0-9]+(?=\.)/i,'');}
    catch(error){return '';}
  }

  function removeLegacyDuplicates(body){
    body.querySelectorAll('[data-neralvo-seo="related-guides-v1"]').forEach(function(node){node.remove();});
  }

  function placeVerdictFirst(body){
    var verdict=body.querySelector('[data-neralvo-upgrade="verdict"]');
    if(verdict&&body.firstElementChild!==verdict)body.insertBefore(verdict,body.firstElementChild);
  }

  function placeIntentRoute(body){
    var route=document.getElementById('nr-software-first-route');
    var verdict=body.querySelector('[data-neralvo-upgrade="verdict"]');
    if(route&&verdict&&verdict.parentNode)verdict.insertAdjacentElement('afterend',route);
  }

  function placeTopicMedia(body){
    var featured=document.querySelector('.nr-featured[data-nr-featured-kind="topic"]');
    if(!featured)return;
    var authoredImage=body.querySelector('img');
    var featuredImage=featured.querySelector('img');
    if(authoredImage&&featuredImage&&imageFilename(authoredImage.currentSrc||authoredImage.src)===imageFilename(featuredImage.currentSrc||featuredImage.src)){
      featured.remove();
      return;
    }
    var verdict=body.querySelector('[data-neralvo-upgrade="verdict"]');
    if(verdict&&verdict.parentNode){
      var route=document.getElementById('nr-software-first-route');
      var toc=document.getElementById('nr-article-toc');
      var anchor=verdict;
      if(route&&route.parentNode===verdict.parentNode)anchor=route;
      if(toc&&toc.parentNode===verdict.parentNode)anchor=toc;
      anchor.insertAdjacentElement('afterend',featured);
    }
  }

  function prioritiseLeadImage(body){
    var lead=document.querySelector('.nr-featured[data-nr-featured-kind="topic"] img')||body.querySelector('img');
    if(!lead)return;
    lead.loading='eager';
    lead.setAttribute('fetchpriority','high');
    if(!lead.hasAttribute('decoding'))lead.decoding='async';
  }

  function improveMediaLinksAndTables(body){
    body.querySelectorAll('img').forEach(function(image){
      if(!image.hasAttribute('loading'))image.loading='lazy';
      if(!image.hasAttribute('decoding'))image.decoding='async';
    });
    body.querySelectorAll('iframe').forEach(function(frame){
      if(!frame.hasAttribute('loading'))frame.loading='lazy';
      if(!frame.hasAttribute('title'))frame.title='Embedded media';
    });
    body.querySelectorAll('table').forEach(function(table,index){
      if(!table.hasAttribute('tabindex'))table.tabIndex=0;
      if(!table.hasAttribute('aria-label')&&!table.hasAttribute('aria-labelledby')){
        var caption=table.querySelector('caption');
        table.setAttribute('aria-label',caption?caption.textContent.trim():'Article comparison table '+(index+1));
      }
    });
    body.querySelectorAll('a[href]').forEach(function(link){
      try{
        var url=new URL(link.href,window.location.origin);
        if(url.origin!==window.location.origin){
          var rel=(link.getAttribute('rel')||'').split(/\s+/).filter(Boolean);
          ['noopener','noreferrer','external'].forEach(function(value){if(rel.indexOf(value)===-1)rel.push(value);});
          link.setAttribute('rel',rel.join(' '));
        }
      }catch(error){}
    });
  }

  function initTocRoutes(){
    var toc=document.getElementById('nr-article-toc');
    if(!toc)return;
    document.querySelectorAll('a[href="#nr-article-toc"]').forEach(function(link){
      link.addEventListener('click',function(){toc.hidden=false;toc.open=true;});
    });
  }

  function initReadingProgress(){
    var bar=document.querySelector('[data-nr-reading-progress]');
    var article=document.getElementById('neralvo-article-content');
    if(!bar||!article)return;
    var ticking=false;
    function update(){
      var start=article.offsetTop;
      var distance=Math.max(article.offsetHeight-window.innerHeight,1);
      var progress=Math.min(Math.max((window.scrollY-start)/distance,0),1);
      bar.style.transform='scaleX('+progress.toFixed(4)+')';
      ticking=false;
    }
    function requestUpdate(){
      if(ticking)return;
      ticking=true;
      window.requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll',requestUpdate,{passive:true});
    window.addEventListener('resize',requestUpdate,{passive:true});
  }

  function init(){
    var body=document.getElementById('nr-article-body');
    if(!body)return;
    removeLegacyDuplicates(body);
    placeVerdictFirst(body);
    placeIntentRoute(body);
    improveMediaLinksAndTables(body);
    placeTopicMedia(body);
    prioritiseLeadImage(body);
    initTocRoutes();
    initReadingProgress();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();